import { render, staticRenderFns } from "./ModificaCorso.vue?vue&type=template&id=67ae8f23&scoped=true&"
import script from "./ModificaCorso.vue?vue&type=script&lang=js&"
export * from "./ModificaCorso.vue?vue&type=script&lang=js&"
import style0 from "./ModificaCorso.vue?vue&type=style&index=0&id=67ae8f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae8f23",
  null
  
)

export default component.exports